"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationSecurityPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.OperationSecurityPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    OperationSecurity: 'OPERATION_SECURITY',
});
//# sourceMappingURL=operationSecurity.js.map